import { ROLES } from "../constant/constant";

export const getNavigatePage = (role?: string) => {
    switch (role) {
        case ROLES.ADMINISTRATOR:
        case ROLES.ADMIN:
        case ROLES.SUPER_ADMIN:
        case ROLES.DATA_ADMIN:
            return '/admin-dashboard';
        case ROLES.CASHIER:
            return '/cashier-dashboard';
        case ROLES.USER:
            return '/'
        default:
            return '/unauthorized';
    }
};